/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { getEntities as getDiagLabInventoryTypes } from 'app/entities/diag-lab-inventory-type/diag-lab-inventory-type.reducer';
import { getEntities as getDiagLabInventories } from 'app/entities/diag-lab-inventory/diag-lab-inventory.reducer';
import { createEntity, getEntity, reset, updateEntity } from './diag-lab-inventory-checkout.reducer';

export const DiagLabInventoryCheckoutUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const diagLabInventoryTypes = useAppSelector(state => state.diagLabInventoryType.entities);
  const diagLabInventories = useAppSelector(state => state.diagLabInventory.entities);
  const diagLabInventoryCheckoutEntity = useAppSelector(state => state.diagLabInventoryCheckout.entity);
  const loading = useAppSelector(state => state.diagLabInventoryCheckout.loading);
  const updating = useAppSelector(state => state.diagLabInventoryCheckout.updating);
  const updateSuccess = useAppSelector(state => state.diagLabInventoryCheckout.updateSuccess);

  const handleClose = () => {
    navigate(`/diag-lab-inventory-checkout${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDiagLabs({}));
    dispatch(getDiagLabInventoryTypes({}));
    dispatch(getDiagLabInventories({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.remainingUses !== undefined && typeof values.remainingUses !== 'number') {
      values.remainingUses = Number(values.remainingUses);
    }
    if (values.avgUsesPerItem !== undefined && typeof values.avgUsesPerItem !== 'number') {
      values.avgUsesPerItem = Number(values.avgUsesPerItem);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...diagLabInventoryCheckoutEntity,
      ...values,
      diagLab: diagLabs.find(it => it.id.toString() === values.diagLab?.toString()),
      type: diagLabInventoryTypes.find(it => it.id.toString() === values.type?.toString()),
      inventory: diagLabInventories.find(it => it.id.toString() === values.inventory?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...diagLabInventoryCheckoutEntity,
          diagLab: diagLabInventoryCheckoutEntity?.diagLab?.id,
          type: diagLabInventoryCheckoutEntity?.type?.id,
          inventory: diagLabInventoryCheckoutEntity?.inventory?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.diagLabInventoryCheckout.home.createOrEditLabel" data-cy="DiagLabInventoryCheckoutCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.home.createOrEditLabel">
              Create or edit a DiagLabInventoryCheckout
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="diag-lab-inventory-checkout-id"
                  label={translate('tinyMedicRestApp.diagLabInventoryCheckout.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryCheckout.brandId')}
                id="diag-lab-inventory-checkout-brandId"
                name="brandId"
                data-cy="brandId"
                type="text"
                validate={{
                  maxLength: { value: 150, message: translate('entity.validation.maxlength', { max: 150 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryCheckout.batchNumber')}
                id="diag-lab-inventory-checkout-batchNumber"
                name="batchNumber"
                data-cy="batchNumber"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <UncontrolledTooltip target="batchNumberLabel">
                <Translate contentKey="tinyMedicRestApp.diagLabInventoryCheckout.help.batchNumber" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryCheckout.serialNumber')}
                id="diag-lab-inventory-checkout-serialNumber"
                name="serialNumber"
                data-cy="serialNumber"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryCheckout.remainingUses')}
                id="diag-lab-inventory-checkout-remainingUses"
                name="remainingUses"
                data-cy="remainingUses"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryCheckout.avgUsesPerItem')}
                id="diag-lab-inventory-checkout-avgUsesPerItem"
                name="avgUsesPerItem"
                data-cy="avgUsesPerItem"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryCheckout.active')}
                id="diag-lab-inventory-checkout-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryCheckout.cursor')}
                id="diag-lab-inventory-checkout-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryCheckout.lastUpdated')}
                id="diag-lab-inventory-checkout-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryCheckout.microSec')}
                id="diag-lab-inventory-checkout-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryCheckout.timestampEntry')}
                id="diag-lab-inventory-checkout-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="diag-lab-inventory-checkout-diagLab"
                name="diagLab"
                data-cy="diagLab"
                label={translate('tinyMedicRestApp.diagLabInventoryCheckout.diagLab')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diag-lab-inventory-checkout-type"
                name="type"
                data-cy="type"
                label={translate('tinyMedicRestApp.diagLabInventoryCheckout.type')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabInventoryTypes
                  ? diagLabInventoryTypes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diag-lab-inventory-checkout-inventory"
                name="inventory"
                data-cy="inventory"
                label={translate('tinyMedicRestApp.diagLabInventoryCheckout.inventory')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabInventories
                  ? diagLabInventories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/diag-lab-inventory-checkout" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DiagLabInventoryCheckoutUpdate;
